// src/locales/ta/expenses.js
export const expenses = {
  // Page titles
  manageExpenses: 'செலவுகளை நிர்வகி',
  viewAndManageExpenses: 'உங்கள் வணிக செலவுகளை பதிவு செய்து கண்காணிக்கவும்',

  // Statistics
  totalExpenses: 'மொத்த செலவுகள்',
  totalAmount: 'மொத்த தொகை',
  filteredTotal: 'வடிகட்டிய மொத்தம்',

  // Actions
  recordNewExpense: 'செலவை பதிவு செய்',
  editExpense: 'செலவை திருத்து',
  deleteExpense: 'செலவை நீக்கு',
  createExpense: 'செலவை சேமி',
  updateExpense: 'செலவை புதுப்பி',

  // Fields
  expenseDate: 'செலவு தேதி',
  category: 'வகை',
  subCategory: 'துணை வகை',
  selectCategory: 'வகையை தேர்ந்தெடுக்கவும்',
  selectSubCategory: 'துணை வகையை தேர்ந்தெடுக்கவும் (விருப்பத்தேர்வு)',
  title: 'தலைப்பு / விவரம்',
  amount: 'தொகை',
  paymentMethod: 'கட்டண முறை',
  notes: 'குறிப்புகள்',
  createdBy: 'பதிவு செய்தவர்',

  // Placeholders
  enterTitle: 'செலவு தலைப்பு அல்லது விவரம் உள்ளிடவும்',
  enterAmount: 'தொகையை உள்ளிடவும்',
  enterNotes: 'இந்த செலவு பற்றிய கூடுதல் குறிப்புகள்...',

  // Payment methods
  paymentMethods: {
    cash: 'பணம்',
    bank_transfer: 'வங்கி பரிமாற்றம்',
    credit_card: 'கடன் அட்டை',
    cheque: 'காசோலை',
    mobile_payment: 'மொபைல் பேமெண்ட்',
    other: 'மற்றவை',
  },

  // Search and filters
  searchExpenses: 'தலைப்பின்படி தேடு...',
  allCategories: 'அனைத்து வகைகளும்',
  allPaymentMethods: 'அனைத்து கட்டண முறைகளும்',
  dateFrom: 'தொடக்க தேதி',
  dateTo: 'முடிவு தேதி',

  // Summary
  showingTotal: 'வடிகட்டிய முடிவுகளுக்கான மொத்தம்',

  // Messages
  expenseCreatedSuccessfully: 'செலவு வெற்றிகரமாக பதிவு செய்யப்பட்டது',
  expenseUpdatedSuccessfully: 'செலவு வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
  expenseDeletedSuccessfully: 'செலவு வெற்றிகரமாக நீக்கப்பட்டது',
  failedToLoadExpenses: 'செலவுகளை ஏற்றுவதில் தோல்வி',
  failedToLoadCategories: 'செலவு வகைகளை ஏற்றுவதில் தோல்வி',
  failedToCreateExpense: 'செலவை பதிவு செய்வதில் தோல்வி',
  failedToUpdateExpense: 'செலவை புதுப்பிப்பதில் தோல்வி',
  failedToDeleteExpense: 'செலவை நீக்குவதில் தோல்வி',

  // Empty states
  noExpensesYet: 'எந்த செலவும் பதிவு செய்யப்படவில்லை',
  noExpensesYetDescription: 'உங்கள் முதல் செலவை பதிவு செய்து வணிக செலவு கண்காணிப்பை தொடங்கவும்.',
  noExpensesFound: 'செலவுகள் எதுவும் கிடைக்கவில்லை',
  noExpensesFoundDescription: 'உங்கள் தற்போதைய வடிப்பான்களுக்கு பொருந்தும் செலவுகள் இல்லை. தேடல் அளவுகோல்களை சரிசெய்யுங்கள்.',

  // Delete confirmation
  confirmDelete: 'இந்த செலவை நீக்க விரும்புகிறீர்களா?',
  confirmDeleteDescription: 'இந்த செயலை மாற்ற இயலாது.',

  // Validation
  validation: {
    categoryRequired: 'செலவு வகை தேவை',
    titleRequired: 'தலைப்பு தேவை',
    titleMinLength: 'தலைப்பு குறைந்தது 2 எழுத்துகளாக இருக்க வேண்டும்',
    amountRequired: 'தொகை தேவை',
    amountPositive: 'தொகை ஒரு நேர்மறை எண்ணாக இருக்க வேண்டும்',
    dateRequired: 'செலவு தேதி தேவை',
    paymentMethodRequired: 'கட்டண முறை தேவை',
    fixErrors: 'படிவத்தில் உள்ள பிழைகளை சரிசெய்யவும்',
  },
};
